export default __webpack_public_path__ + "static/media/ESFP-2.2efd3686.png";